import { Component, OnInit, Input, Output, EventEmitter, ViewChildren} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-cpg-registration',
  templateUrl: './cpg-registration.component.html',
  styleUrls: ['./cpg-registration.component.scss']
})
export class CpgRegistrationComponent implements OnInit {

  @Output() registrationResponse = new EventEmitter(); // Registrtion response event

  public registrationForm: FormGroup;
  public buttonLoader: any = false;

  constructor() { }

  ngOnInit(): void {
    // Set registration form
    this.registrationForm = new FormGroup({
      firstName: new FormControl(null, [Validators.required, Validators.minLength(3), Validators.maxLength(30)]),
      lastName: new FormControl(null, [Validators.required, Validators.minLength(3), Validators.maxLength(30)]),
      company: new FormControl(null, [Validators.required, Validators.minLength(3), Validators.maxLength(30)]),
      email: new FormControl(null, [Validators.required, Validators.minLength(3)]),
      phone: new FormControl(null, [Validators.required, Validators.minLength(3)]),
    });
  }

  // Close modal
  async onClose() {
    this.registrationResponse.emit({ registrstionStatus : false, closeModal: true });
  }

  // Registrstion submit
  async onSubmit() {
    if (this.registrationForm.status == 'VALID') {
      this.buttonLoader = true;

      this.registrationResponse.emit({ registrstionStatus : true, closeModal: true });
    }
  }

}
